<template>
  <div>
    <div v-if="Business">
      <div v-if="$vuetify.breakpoint.xsOnly">
        <div class="text-center mt-4">
          <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />

          <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
          <div v-if="Business.phoneNumber">
            {{ Business.phoneNumber | USPhoneNumber }}
          </div>
          <div>
            <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
              }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
            <span v-if="Business.zip">{{ Business.zip }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
          <v-flex>
            <img v-if="Business.imageUrl" height="100" :src="Business.imageUrl" alt="Logo" />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <div class="text-right">
              <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
              <div>
                <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
                  }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
                <span v-if="Business.zip">{{ Business.zip }}</span>
              </div>
              <div v-if="Business.phoneNumber">
                {{ Business.phoneNumber | USPhoneNumber }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-container grid-list-lg :fluid="$vuetify.breakpoint.xsOnly" v-if="!collected">

      <v-card flat>
        <v-card-title class="text-h4">
          Online Donation
        </v-card-title>

        <v-stepper vertical v-model="step" class="elevation-0">

          <v-stepper-step :complete="step > 1" step="1">
            Donation
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-layout column wrap class="mt-3">
              <v-flex>
                <div class="font-weight-regular mb-2 mt-2 black--text">Select Category <span class="red--text">*</span>
                </div>
                <v-btn-toggle active-class="custom-active-class" dense mandatory v-model="selectedCategory"
                  color="primary" group>
                  <v-row class="ml-2 mt-1">
                    <v-btn v-for="category in DonationCategories" :key="category.id" outlined :value="category" class="ma-1">
                      {{ category.name }}
                    </v-btn>
                  </v-row>
                </v-btn-toggle>
              </v-flex>
              <v-flex>
                <div class="font-weight-regular mb-2 mt-2 black--text">Payment Cycle <span class="red--text">*</span>
                </div>
                <v-btn-toggle active-class="custom-active-class" mandatory dense v-model="paymentCycle" color="primary"
                  group>
                  <v-row class="ml-2 mt-1">
                    <v-btn value="oneTime" outlined class="ma-1">
                      One Time
                    </v-btn>
                    <v-btn value="everyFriday" outlined class="ma-1">
                      Every Friday
                    </v-btn>
                    <v-btn value="monthly" outlined class="ma-1">
                      Monthly
                    </v-btn>
                  </v-row>
                </v-btn-toggle>
              </v-flex>
              <v-flex v-if="paymentCycle === 'monthly'">
                <div class="font-weight-regular mb-2 mt-2 black--text">Number of month <span class="red--text">*</span>
                </div>
                <v-btn-toggle active-class="custom-active-class" mandatory dense v-model="numberOfMonth" color="primary"
                  group>
                  <v-row class="ml-2 mt-1">
                    <v-btn :value="month" :key="month" outlined class="ma-1" v-for="month in months">
                      {{ month }}
                    </v-btn>
                    <v-btn value="lifetime" outlined class="ma-1">
                      Lift Time
                    </v-btn>

                  </v-row>
                </v-btn-toggle>
              </v-flex>
              <v-flex v-if="paymentCycle === 'everyFriday'">
                <div class="font-weight-regular mb-2 mt-2 black--text">Number of Friday <span class="red--text">*</span>
                </div>
                <v-btn-toggle active-class="custom-active-class" mandatory dense v-model="numberOfFriday"
                  color="primary" group>
                  <v-row class="ml-2 mt-1">
                    <v-btn :value="friday" :key="friday" outlined class="ma-1" v-for="friday in fridays">
                      {{ friday }}
                    </v-btn>
                    <v-btn value="lifetime" outlined class="ma-1">
                      Lift Time
                    </v-btn>

                  </v-row>
                </v-btn-toggle>
              </v-flex>
              <v-flex>

                <div class="font-weight-regular mb-2 mt-2 black--text">Choose an Amount or Enter Custom Amount <span
                    class="red--text">*</span></div>

                <v-btn-toggle active-class="custom-active-class" dense mandatory v-model="selectedAmount"
                  color="primary" group>
                  <v-row class="ml-2 mt-1">
                    <v-btn v-for="amount in amountValue" :key="amount.name" outlined class="ma-1">
                      {{ amount.name }}
                    </v-btn>
                  </v-row>

                </v-btn-toggle>
              </v-flex>

              <v-flex>
                <v-flex xs12 md4 class="pl-0 mt-2">
                  <v-text-field class="al-r" prefix="$" v-model="amount" outlined dense label="Donation Amount"
                    type="number" hide-details></v-text-field>

                </v-flex>
                <div class="text--secondary caption">$10 is the minimum online donation. All donations are tax
                  deductible.</div>
              </v-flex>
              <v-flex xs12>
                <v-card color="green lighten-5" style="border-color='green !important'" outlined class="rounded">
                  <v-card-text class="py-0">
                    <div class="text-center">
                      <v-checkbox v-model="addFee">
                        <template v-slot:label>
                          <div>Please add {{ feeAmount | currency }} to cover processing fees and other expenses
                            associated
                            with my
                            donation.</div>
                        </template>
                      </v-checkbox>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>




            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <!-- <v-btn text @click="step = step - 1">Back</v-btn> -->
              <v-spacer></v-spacer>
              <v-btn large @click="infoStep" :disabled="!allowStep2" color="primary">Next</v-btn>
            </v-card-actions>

          </v-stepper-content>

          <v-stepper-step :complete="step > 2" step="2">
            Your Information
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-layout row wrap class="mt-2">
              <v-flex xs12 sm6>
                <v-text-field autofocus v-model="Donor.name" outlined dense label="Name" hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field type="number" v-model="Donor.phoneNumber" outlined dense label="Phone Number"
                  hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-model="Donor.email" outlined dense label="Email Address" hide-details></v-text-field>
              </v-flex>
            </v-layout>

            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-btn text @click="step = step - 1" large>Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn large @click="paymentInfo" color="primary">Next</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="3">
            Payment
          </v-stepper-step>
          <v-stepper-content step="3">

            <CreditCard v-if="step === 3" @submit="infoCollect" :localCollectOnly="true" :hideBank="true" :donor="Donor"
              :public="true" />


            <v-card v-if="showSecondCollection" color="green lighten-5" style="border-color='green !important'" outlined
              class="rounded mx-4">
              <v-card-text class="py-0">
                <div class="text-center">
                  <v-checkbox v-model="addFeeSecond">
                    <template v-slot:label>
                      <div>Please add {{ feeAmount | currency }} to cover processing fees and other expenses associated
                        with my
                        donation.</div>
                    </template>
                  </v-checkbox>
                </div>
              </v-card-text>
            </v-card>


            <p class="mt-5" v-if="Business">
              By clicking the "Submit" button, you are authorizing an electronic fund transfer from the specified
              account
              for this transaction in the specified amount to {{ Business.name }}.
            </p>

            <!-- :disabled="loading" :loading="loading" -->
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-btn text @click="step = step - 1" large>Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn large @click="submit" :disabled="loading" :loading="loading" rounded class="px-5"
                color="primary">Donate {{
                  totalDonationAmount | currency
                }}</v-btn>
            </v-card-actions>
          </v-stepper-content>

        </v-stepper>


      </v-card>
      <div class="text-right">
        Power by: <span>taleem.app</span> -
        <span class="caption">{{ version }}</span>
      </div>
    </v-container>
    <v-container grid-list-lg :fluid="$vuetify.breakpoint.xsOnly" v-else>
      <v-card flat>
        <v-card-text>
          <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation"
            @onComplete="showHomeButton = true" />
          <div class="text-center">
            <div class="text-h5">All Set</div>
            <div class="mt-3">
              The Prophet, upon be peace, said: “The believer’s shade on the Day of Resurrection will be his charity.”
              <span class="font-weight-bold">Al-Tirmidhi</span>
            </div>
          </div>
          <div class="text-center mt-5" v-if="showHomeButton">
            <v-slide-y-transition>
              <v-btn block large @click="$router.go(-1)" color="success">Home</v-btn>
            </v-slide-y-transition>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-5">
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import applicationService from "@/modules/Application/service.js";
const { validationMixin } = require("vuelidate");
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");
const { required, email } = require("vuelidate/lib/validators");
// import payCompassService from "@/modules/PayCompass/service.js";
import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'

export default {
  name: 'masjid-donation',
  data() {
    return {
      fridays: ['26', '52', '78', '90', '115'],
      months: ['6', '12', '18', '24', '36'],
      numberOfMonth: '12',
      numberOfFriday: '52',
      loading: false,
      showHomeButton: false,
      collected: false,
      card: null,
      showSecondCollection: true,
      totalDonationAmount: 0,
      allowStep2: true,
      addFee: false,
      addFeeSecond: false,
      feeAmount: 22,
      DonationCategories: null,
      paymentCycle: 'oneTime',
      selectedCategory: null,
      selectedAmount: 0,
      showOtherInputBox: false,
      Donor: {
        name: null,
        phoneNumber: null,
        email: null,
      },
      step: 1,
      Business: null,
      paymentMethod: {
        accountName: null,
        routingNumber: null,
        accountNumber: null,
      },
      showCard: false,
      amountValue: [
        { name: '$ 10.00', value: 10 },
        { name: '$ 20.00', value: 20 },
        { name: '$ 50.00', value: 50 },
        { name: '$ 100.00', value: 100 },
        { name: '$ 150.00', value: 150 },
        { name: '$ 200.00', value: 200 },
        { name: '$ 500.00', value: 500 },
      ],
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
      amount: 0,
      tags: [
        'Work',
        'Home Improvement',
        'Vacation',
        'Food',
        'Drawers',
        'Shopping',
        'Art',
        'Tech',
        'Creative Writing',
      ],
    }
  },
  created() {
    this.loadBusiness()
    this.loadCategories()
    setTimeout(() => {
      this.selectedAmount = 1
    }, 100);
  },
  components: {
    CreditCard,
    Lottie,
  },
  computed: {
    version() {
      return pjson.version;
    },
  },
  mixins: [validationMixin],
  validations: {
    Donor: {
      name: {
        required,
      },
      phoneNumber: {
        required,
      },
      email: {
        email,
      },
    },

  },
  watch: {
    addFeeSecond() {
      this.setDonationAmount()
    },
    addFee(val) {
      if (val) {
        this.showSecondCollection = false
      } else {
        this.showSecondCollection = true
      }
      this.setDonationAmount()
    },
    amount() {
      this.setDonationAmount()
    },
    selectedAmount() {
      this.showOtherInput()
    }
  },
  methods: {
    infoCollect(val) {
      this.loading = true;
      this.card = val
      let data = {};
      data.Donor = this.Donor
      // data.ProductId = this.selectedCategory.id
      data.productName = this.selectedCategory.name
      data.cycle = this.paymentCycle
      data.numberOfMonth = this.numberOfMonth
      data.numberOfFriday = this.numberOfFriday
      data.Donor = this.Donor
      data.card = this.card
      data.card.donationCategoryId = this.selectedCategory.id
      if (this.addFee || this.addFeeSecond) {
        data.processingFeeCollect = true
      } else {
        data.processingFeeCollect = false
      }
      data.amount = this.amount
      data.feeAmount = this.feeAmount

      if (data.processingFeeCollect) {
        data.finalAmount = parseFloat(data.amount) + parseFloat(data.feeAmount)
      } else {
        data.finalAmount = parseFloat(data.amount)
      }

      console.log('data sending', this.Business, data)

      try {

        applicationService
          .publicDonationCreate(this.Business.code, data)
          .then((response) => {
            console.log("response publicSponsorCreate", response);
            // this.infoCollected = true;
            // this.loadingSubmit = false;
            this.collected = true
            this.loading = false
          })
          .catch((error) => {
            this.loadingSubmit = false;
            this.loading = false;
            console.log("err", error);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      } catch (error) {
        this.loading = false;

console.log("error adding card3", error);
      }



    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    setDonationAmount() {
      if (this.amount > 0) {
        this.feeAmount = (this.amount * 3.4 / 100) + .30
        this.allowStep2 = true
      } else {
        this.feeAmount = 0
        this.allowStep2 = false
      }

      if (this.addFee || this.addFeeSecond) {
        this.totalDonationAmount = parseFloat(this.amount) + parseFloat(this.feeAmount)
      } else {
        this.totalDonationAmount = parseFloat(this.amount)
      }


    },
    paymentInfo() {
      this.step = 3
    },
    infoStep() {
      this.step = 2
    },
    async submit() {
      // this.$v.card.$touch();
      // if (this.paymentType === 'card') {
      //   this.$v.card.$touch();
      //   if (this.$v.card.$invalid) {
      //     this.$swal
      //       .mixin({
      //         toast: true,
      //         position: "top-end",
      //         showConfirmButton: false,
      //         timer: 3000,
      //       })
      //       .fire({
      //         icon: "error",
      //         title: this.$t("toastMessage.text.invalidFields"),
      //       });
      //     return false
      //   }
      // }
      try {
        this.$events.emit("submitCreditCard");



        // data.sponsor = this.sponsor
        // data.BusinessId = this.Info.BusinessId,




        // data.card = encryptor.encrypt(JSON.stringify(card))

        // payCompassService.addCard(data).then((response) => {
        //   console.log('add card response working', response)
        //   // this.cardCollected = true;
        //   this.reset()
        //   this.dialog = !this.dialog
        //   this.$emit('submit')

        // }).catch(error => {
        //   this.loading = false;
        //   console.log("error adding card2", error);
        //   this.$swal
        //     .mixin({
        //       toast: true,
        //       position: "top-end",
        //       showConfirmButton: false,
        //       timer: 3000,
        //     })
        //     .fire({
        //       icon: "error",
        //       title: error.data.message,
        //     });
        // })






        // this.$emit('submitCreditCard')




        // payCompassService.addCard(data).then((response) => {
        //   console.log('add card response working', response)
        //   // this.cardCollected = true;
        //   this.reset()
        //   this.dialog = !this.dialog
        //   this.$emit('submit')

        // }).catch(error => {
        //   this.loading = false;
        //   console.log("error adding card2", error);
        //   this.$swal
        //     .mixin({
        //       toast: true,
        //       position: "top-end",
        //       showConfirmButton: false,
        //       timer: 3000,
        //     })
        //     .fire({
        //       icon: "error",
        //       title: error.data.message,
        //     });
        // })

      } catch (error) {
        this.loading = false;

        console.log("error adding card3", error);
      }
    },
    showOtherInput() {
      // console.log('this.selectedAmount', this.selectedAmount)
      const index1 = this.amountValue[this.selectedAmount];
      console.log('index1', index1)
      // if (index1 && index1.name === 'Other') {
      //   this.showOtherInputBox = true
      //   this.amount = 0
      //   setTimeout(() => {
      //     this.$refs.otherAmount.focus();
      //   }, 100);
      // } else {
      //   this.showOtherInputBox = false
      //   this.amount = index1.value
      // }
      this.amount = index1.value
      // console.log('index1', index1)

    },
    loadBusiness() {
      let id = this.$route.params.id;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          // this.StripeKey = this.Business.metadata.publicStripeId;
          // this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    loadCategories() {
      let id = this.$route.params.id;
      console.log('getting id', id)
      applicationService
        .getPublicDonationCategoryList({ key: id, publicDonation: true })
        .then((response) => {
          console.log("response Category", response);
          this.DonationCategories = response.data
          // this.StripeKey = this.Business.metadata.publicStripeId;
          // this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error getting category", error);
          // this.$router.push({ name: "pagenotfound" });
        });
    },
  }
}
</script>

<style scoped>
.v-application .green.lighten-5 {
  background-color: #e8f5e9 !important;
  border-color: green !important;
}

.custom-active-class {
  background-color: green;
  /* Change to the color you want for the active button */
  color: white;
  /* Change to the text color you want for the active button */
}
</style>